module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "mfa-enable.f2e108a8.png";